import { render, staticRenderFns } from "./UserDevicesTable.vue?vue&type=template&id=1ff2fb2a&scoped=true&"
import script from "./UserDevicesTable.vue?vue&type=script&lang=js&"
export * from "./UserDevicesTable.vue?vue&type=script&lang=js&"
import style0 from "./UserDevicesTable.vue?vue&type=style&index=0&id=1ff2fb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff2fb2a",
  null
  
)

export default component.exports